import axios from 'axios'


export default async _ => {
    const url = 'https://ipwhois.app/json/'

    try {
       const response = await axios.get(url)
        return response.data
    } catch (error) {
        console.log(error)
    }
}